import React, { useEffect, useState, Fragment } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { navigateToCategory } from "../../../utils/utils";
import Translate from "../../../Components/MultiLanguage/Translate";
import SectionSlider from "../../../Components/slider/SectionSlider";

const Genres = ({ data }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const navigate = useNavigate();
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const itemShape = data?.item_shape || "round";
  const imageRequired = data?.image_required;

  const displayedData = data?.shows;

  return (
    <>
      <SectionSlider
        title={data?.category_name || <Translate textKey={"genres"} />}
        list={displayedData}
        className="genres-block streamit-block"
        data={data}
        margin={true}
        notViewAll={true}
      >
        {(item) => (
          <div
            className={`category-name ${itemShape}`}
            onClick={() => navigateToCategory(navigate, item)}
          >
            {imageRequired && item?.logo ? (
              <div className={`${itemShape}-container`}>
                <img
                  src={item?.logo}
                  onError={(e) => {
                    e.target.src =
                      projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE;
                  }}
                  alt="Banner"
                />
              </div>
            ) : (
              <div className={`${itemShape}-container placeholder`}>
                <h1 className="placeholder-text">
                  {item?.category_name}
                </h1>
              </div>
            )}
            <div className="genre-name">
              {item?.category_name}
            </div>
          </div>
        )}
      </SectionSlider>
    </>
  );
};

export default Genres;
